import React from "react";
import { Component } from "react";
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel_LocationSite as Select } from "../../../common/custom-form/select-filter.component";
import Translation from "../../../common/translation/translation.component";
import { MAX_LENGTH } from "../../../../constants/external-constants";
import CustomSearchableSelectWrapper from "../../../common/custom-form/custom-searchable-select-wrapper.component";
import CustomSearchableSelect from "../../../common/custom-form/custom-searchable-select.component";
export class AddressDetails extends Component {
    
    render() {
        const { locationDetails, translator, inventoryAllLocations, fieldProp, onChangeAction, formName } = this.props;
        return (
            <div className="details-4-col-container address-detail-container">
                 <CustomSearchableSelect
                    className="form-control required"
                    label={translator("location_site_id_capital")}
                    options={inventoryAllLocations}
                    selected={locationDetails.locationID}
                    onChange={(value) => onChangeAction(`${fieldProp}.locationID`, value)}
                    placeholder={`${translator('select_placeholder')}`}
                    fieldProp={`${fieldProp}.locationID`}
                    tagName='LocationSite'
                    name={`${formName}${fieldProp}.locationID`}
                    optionLabelKey={{
                        Key: 'LocationId',
                        Value: 'LocationSite'
                    }}
                    maxLength={MAX_LENGTH.limit_100}
                />

                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"address_1_capital"} />}
                    value={locationDetails.address1}
                    fieldProp={`${fieldProp}.address1`}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"address_2_capital"} />}
                    value={locationDetails.address2}
                    fieldProp={`${fieldProp}.address2`}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"location_type_capital"} />}
                    value={locationDetails.locationType}
                    fieldProp={`${fieldProp}.locationType`}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"city_capital"} />}
                    value={locationDetails.locationCity}
                    fieldProp={`${fieldProp}.locationCity`}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"state_capital"} />}
                    value={locationDetails.locationState}
                    fieldProp={`${fieldProp}.locationState`}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"country_capital"} />}
                    value={locationDetails.locationCountry}
                    fieldProp={`${fieldProp}.locationCountry`}
                    disabled={true}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"zip_capital"} />}
                    value={locationDetails.locationZip}
                    fieldProp={`${fieldProp}.locationZip`}
                    disabled={true}
                />
                <div className="additional-textarea-info">
                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"demarc_location_capital"} />}
                        value={locationDetails.demarcLocation}
                        placeholder={`${translator('enter_text_placeholder')}`}
                        maxLength={MAX_LENGTH.limit_500}
                        fieldProp={`${fieldProp}.demarcLocation`}
                        disabled={false}
                    />
                </div>
            </div>
        )
    }
};

export default AddressDetails